import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=7f4a4a3d&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=7f4a4a3d&lang=scss&scoped=true&"
import style1 from "./Button.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a4a3d",
  null
  
)

export default component.exports